// Poll until workspace mode matches (post bucket / mode-rail navigation).

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";

export type WaitForPrimaryModeOptions = {
  timeoutMs?: number;
  intervalMs?: number;
  isCancelled?: () => boolean;
};

export function waitForPrimaryMode(
  readMode: () => PrimaryMode,
  targetMode: PrimaryMode,
  options: WaitForPrimaryModeOptions = {},
): Promise<boolean> {
  const timeoutMs = options.timeoutMs ?? 3_000;
  const intervalMs = options.intervalMs ?? 80;
  const isCancelled = options.isCancelled ?? (() => false);

  if (readMode() === targetMode) return Promise.resolve(true);
  if (typeof window === "undefined") return Promise.resolve(false);

  return new Promise((resolve) => {
    const started = Date.now();

    const tick = () => {
      if (isCancelled()) {
        resolve(false);
        return;
      }
      if (readMode() === targetMode) {
        resolve(true);
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        resolve(readMode() === targetMode);
        return;
      }
      window.setTimeout(tick, intervalMs);
    };

    tick();
  });
}
